<template>
  <div class="v-data-table report bordered--table theme--light">
    <template v-for="item in list">
      <table class="report table table-bordered" v-if="type === 'all' || type === 'estimation'" :key="item.projectid">
        <tbody>
          <tr style="background: #666767 !important; color: #fff;">
            <td :colspan="headers.length"><b>{{ $t('message.stamp.project') }}: {{item.projectnumber || ''}} {{ item.projectname || '' }}{{ item.projectresponsible ? `, ${item.projectresponsible}` : ''}}</b></td>
          </tr>
          <tr>
            <td v-for="(head, index) in headers" :width="head.width" :key="index"><b>{{ head.text }}</b></td>
          </tr>
          <tr v-for="hour in item.hours" :key="hour.id">
            <td v-for="(head, index) in headers" :key="index">
              <template v-if="head.name === 'date'">{{ hour[head.name] | dateFormat }}</template>
              <template v-else-if="head.name === 'hours'">{{ hour[head.name] | replaceDotWithComma }}</template>
              <template v-else>{{ hour[head.name] }}</template>
            </td>
          </tr>
          <tr style="background: #fed8b1 !important;">
            <td :colspan="headers.length"><b>{{ $t('message.reports.total') }}: {{ $format.getSumBy(item.hours, x => x.hours) | replaceDotWithComma }}</b></td>
          </tr>
          <tr style="background: #fed8b1 !important;" v-if="type === 'estimation'">
            <td :colspan="headers.length">
              <p><b>{{ $t('message.reports.estimation') }}: {{ item.estimationhrs | replaceDotWithComma }}</b></p>
              <p><b>{{ $t('message.reports.cost') }}: {{ item.cost || '0' | replaceDotWithComma }}</b></p>
              <p><b>{{ $t('message.common.receivedPayment') }}: {{ item.received_payment || '0' | replaceDotWithComma }}</b></p>
              <p><b>{{ $t('message.reports.userCost') }}: {{ item.usercost || '0' | replaceDotWithComma }}</b></p>
              <p><b>{{ $t('message.reports.progress') }}: {{ item.progress || '0' | replaceDotWithComma }} %</b></p>
              <p><b>{{ $t('message.reports.receivedPaymentProgress') }}: {{ item.received_payment_progress || '0' | replaceDotWithComma }} %</b></p>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <table class="report table table-bordered" v-if="type === 'sum'">
      <tbody>
        <tr>
          <td width="70%"><b>{{ $t('message.stamp.project') }}</b></td>
          <td width="30%"><b>{{ $t('message.reports.total') }}</b></td>
        </tr>
        <tr v-for="item in list" :key="item.projectid">
          <td>{{ item.projectnumber || '' }} {{ item.projectname || '' }}{{ item.projectresponsible ? `, ${item.projectresponsible}` : ''}}</td>
          <td>{{ $format.getSumBy(item.hours, x => x.hours) | replaceDotWithComma }}</td>
        </tr>
      </tbody>
    </table>
    <table class="report table table-bordered" v-if="type === 'sum_both'">
      <tbody>
        <tr>
          <td width="40%"><b>{{ $t('message.stamp.project') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.total') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.estimation') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.progress') }} %</b></td>
        </tr>
        <tr v-for="item in list" :key="item.projectid">
          <td>{{ item.projectnumber || '' }} {{ item.projectname || '' }}{{ item.projectresponsible ? `, ${item.projectresponsible}` : ''}}</td>
          <td>{{ $format.getSumBy(item.hours, x => x.hours) | replaceDotWithComma }}</td>
          <td>{{ item.estimationhrs | replaceDotWithComma }}</td>
          <td>{{ item.progress || '0' | replaceDotWithComma }} %</td>
        </tr>
      </tbody>
    </table>
    <template><!-- v-if="false" -->
      <table class="report table table-bordered"><!--  v-if="type === 'all' || type === 'estimation'" -->
        <tbody>
          <tr style="background: #fed8b1 !important;">
            <td :colspan="headers.length"><b>{{ $t('message.reports.totalProjectHours')  }}: {{ getProjectsTotal() | replaceDotWithComma }}</b></td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>
<script>
export default {
  props: ['type', 'list', 'headers'],
  methods: {
    getProjectsTotal () {
      let total = 0
      this.list.forEach(item => {
        total += this.$format.getSumBy(item.hours, x => x.hours)
      })
      return total
    }
  }
}
</script>
<style>
table.report > tbody > tr > td p {
  margin-bottom: 2px !important;
}
table.report > tbody > tr > td p:last-child {
  margin-bottom: 8px !important;
}
</style>
